const ACTIONS = {
    //  Reducer handled constants
    //  Dispatched by action middleware. Handled by Reducers
    CIVIL_CODE_DISCLAIMER_MODAL_OPEN: 'LISTING/CIVIL_CODE_DISCLAIMER_MODAL_OPEN',
    REQUEST_TO_BOOK_MODAL_OPEN: 'LISTING/REQUEST_TO_BOOK_MODAL_OPEN',
    INQUIRY_MODAL_OPEN: 'LISTING/INQUIRY_MODAL_OPEN',
    DESCRIPTION_MODAL_OPEN: 'LISTING/DESCRIPTION_MODAL_OPEN',
    UNIT_DESCRIPTION_MODAL_OPEN: 'LISTING/UNIT_DESCRIPTION_MODAL_OPEN',
    GENERATED_DESCRIPTION_MODAL_OPEN: 'LISTING/GENERATED_DESCRIPTION_MODAL_OPEN',
    AMENITY_MODAL_OPEN: 'LISTING/AMENITY_MODAL_OPEN',
    OWNER_PROFILE_MODAL_OPEN: 'LISTING/OWNER_PROFILE_MODAL_OPEN',
    SEARCH_MODAL_OPEN: 'LISTING/SEARCH_MODAL_OPEN',
    SEARCH_GUEST_PICKER_MODAL_OPEN: 'LISTING/SEARCH_GUEST_PICKER_MODAL_OPEN',
    SEARCH_DATE_PICKER_MODAL_OPEN: 'LISTING/SEARCH_DATE_PICKER_MODAL_OPEN',
    INQUIRY_MSG_RESET: 'LISTING/INQUIRY_MSG_RESET',
    LOADING_RATE: 'LISTING/LOADING_RATE',
    LOADED_RATE: 'LISTING/LOADED_RATE',
    LOGIN_MODAL_OPEN: 'LISTING/LOGIN_MODAL_OPEN',
    INQUIRY_LOGIN_MODAL_OPEN: 'LISTING/INQUIRY_LOGIN_MODAL_OPEN',
    RATE_IS_VALID: 'LISTING/RATE_IS_VALID',
    DATES_ARE_VALID: 'LISTING/DATES_ARE_VALID',
    GUESTS_ARE_VALID: 'LISTING/GUESTS_ARE_VALID',
    MAP_MODAL_OPEN: 'LISTING/MAP',
    MAP_RESET: 'LISTING/MAP_RESET',
    LOCATION_MODAL_OPEN: 'LISTING/LOCATION_MODAL_OPEN',
    REVIEWS_MODAL_OPEN: 'LISTING/REVIEWS_MODAL_OPEN',
    SET_REVIEWS_ID: 'LISTING/SET_REVIEWS_ID',
    PRICING_INFO_RESET: 'LISTING/PRICING_INFO_RESET',
    VIRTUAL_TOUR_MODAL_OPEN: 'LISTING/VIRTUAL_TOUR_MODAL_OPEN',
    VERTICAL_GALLERY_MODAL_OPEN: 'LISTING/VERTICAL_GALLERY_MODAL_OPEN',
    IMAGE_CAROUSEL_MODAL_OPEN: 'LISTING/IMAGE_CAROUSEL_MODAL_OPEN',
    TOI_MODAL_OPEN: 'LISTING/TOI_MODAL_OPEN',
    //  Action constants
    //  Used to bind action middleware.
    LOG_TO_SERVER: 'LISTING/LOG_TO_SERVER',
    SET_TRIP_COOKIE: 'SET_TRIP_COOKIE',
    FETCH_USER_DATA_SUCCESS: 'LISTING/FETCH_USER_DATA_SUCCESS',
    PAGE_LOADED: 'LISTING/PAGE_LOADED',

    //  Guest selector modal actions
    UPDATE_MODAL_STATE: 'LISTING/UPDATE_MODAL_STATE',
    OPEN_GUEST_SELECTOR_MODAL: 'LISTING/OPEN_GUEST_SELECTOR_MODAL',
    CLOSE_GUEST_SELECTOR_MODAL: 'LISTING/CLOSE_GUEST_SELECTOR_MODAL',

    OPEN_DATE_PICKER_MODAL: 'LISTING/OPEN_DATE_PICKER_MODAL',
    CLOSE_DATE_PICKER_MODAL: 'LISTING/CLOSE_DATE_PICKER_MODAL',

    PRIMARY_CTA_ACTIVATED: 'LISTING/PRIMARY_CTA_ACTIVATED',
    TRANSLATE_PROPERTY_DESCRIPTION_SUCCESS: 'LISTING/TRANSLATE_PROPERTY_DESCRIPTION_SUCCESS',
    SAVE_PROPERTY_DESCRIPTION: 'LISTING/SAVE_PROPERTY_DESCRIPTION'
};

const ACTION_CREATORS = {
    updateModalState(modalState) {
        return {
            type: ACTIONS.UPDATE_MODAL_STATE,
            payload: {
                modalState
            }
        };
    },
    primaryCtaActivated(actionLocation) {
        return {
            type: ACTIONS.PRIMARY_CTA_ACTIVATED,
            payload: {
                actionLocation
            }
        };
    },
    openDatePickerModal() {
        return {type: ACTIONS.OPEN_DATE_PICKER_MODAL, payload: {}};
    },
    closeDatePickerModal(isCancel = false) {
        return {
            type: ACTIONS.CLOSE_DATE_PICKER_MODAL,
            payload: {
                isCancel
            }
        };
    },
    openGuestSelectorModal() {
        return {type: ACTIONS.OPEN_GUEST_SELECTOR_MODAL, payload: {}};
    },
    closeGuestSelectorModal(isCancel) {
        return {
            type: ACTIONS.CLOSE_GUEST_SELECTOR_MODAL,
            payload: {
                isCancel
            }
        };
    },
    logToServer(data) {
        return {
            type: ACTIONS.LOG_TO_SERVER,
            payload: {
                data
            }
        };
    },
    setRequestToBookModalOpen(isOpen) {
        return {
            type: ACTIONS.REQUEST_TO_BOOK_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setMapModalOpen(isOpen) {
        return {
            type: ACTIONS.MAP_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setLocationModalOpen(isOpen) {
        return {
            type: ACTIONS.LOCATION_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    resetMapState() {
        return {
            type: ACTIONS.MAP_RESET,
            payload: {}
        };
    },
    setCivilCodeDisclaimerModalOpen(isOpen) {
        return {
            type: ACTIONS.CIVIL_CODE_DISCLAIMER_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setInquiryModalOpen(isOpen) {
        return {
            type: ACTIONS.INQUIRY_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    resetInquiryState() {
        return {
            type: ACTIONS.INQUIRY_MSG_RESET,
            payload: {}
        };
    },
    setLoginModalOpen(isOpen) {
        return {
            type: ACTIONS.LOGIN_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setInquiryLoginModalOpen(isOpen) {
        return {
            type: ACTIONS.INQUIRY_LOGIN_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setReviewsModalOpen(isOpen) {
        return {
            type: ACTIONS.REVIEWS_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    loadingRate(loading = true) {
        return {
            type: ACTIONS.LOADING_RATE,
            payload: {
                loadingRate: loading
            }
        };
    },
    loadedRate(pricingInfo = {}, priceDetails = {}, pricingKey = {}) {
        return {
            type: ACTIONS.LOADED_RATE,
            payload: {
                loadingRate: false,
                pricingInfo,
                priceDetails,
                pricingKey
            }
        };
    },
    pricingInfoReset(pricingKey = {}) {
        return {
            type: ACTIONS.PRICING_INFO_RESET,
            payload: {
                pricingKey
            }
        };
    },
    datesAreValid(validDates = {}) {
        return {
            type: ACTIONS.DATES_ARE_VALID,
            payload: {
                validDates
            }
        };
    },
    guestsAreValid(validGuests) {
        return {
            type: ACTIONS.GUESTS_ARE_VALID,
            payload: {
                validGuests
            }
        };
    },
    pageLoaded() {
        return {
            type: ACTIONS.PAGE_LOADED,
            payload: {}
        };
    },
    fetchUserDataSuccess(userData) {
        return {
            type: ACTIONS.FETCH_USER_DATA_SUCCESS,
            payload: {
                userData
            }
        };
    },
    updateTripDataCookie() {
        return {
            type: ACTIONS.SET_TRIP_COOKIE,
            payload: {}
        };
    },
    setDescriptionModalOpen(isOpen) {
        return {
            type: ACTIONS.DESCRIPTION_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setUnitDescriptionModalOpen(isOpen) {
        return {
            type: ACTIONS.UNIT_DESCRIPTION_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setGeneratedDescriptionModalOpen(isOpen) {
        return {
            type: ACTIONS.GENERATED_DESCRIPTION_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setAmenityModalOpen(isOpen) {
        return {
            type: ACTIONS.AMENITY_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setOwnerProfileModalOpen(isOpen) {
        return {
            type: ACTIONS.OWNER_PROFILE_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setSearchModalOpen(isOpen) {
        return {
            type: ACTIONS.SEARCH_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setSearchDatePickerModalOpen(isOpen) {
        return {
            type: ACTIONS.SEARCH_DATE_PICKER_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setSearchGuestPickerModalOpen(isOpen) {
        return {
            type: ACTIONS.SEARCH_GUEST_PICKER_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setImageCarouselModalOpen(isOpen) {
        return {
            type: ACTIONS.IMAGE_CAROUSEL_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setVerticalGalleryModalOpen(isOpen) {
        return {
            type: ACTIONS.VERTICAL_GALLERY_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setVirtualTourModalOpen(isOpen) {
        return {
            type: ACTIONS.VIRTUAL_TOUR_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    setToiModalOpen(isOpen) {
        return {
            type: ACTIONS.TOI_MODAL_OPEN,
            payload: {
                isOpen
            }
        };
    },
    translateDescriptionSuccess(localizedDescription) {
        return {
            type: ACTIONS.TRANSLATE_PROPERTY_DESCRIPTION_SUCCESS,
            payload: {
                localizedDescription
            }
        };
    },
    savePropertyDescription(descriptionToSave, locale) {
        return {
            type: ACTIONS.SAVE_PROPERTY_DESCRIPTION,
            payload: {
                locale,
                descriptionToSave
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
